import React from "react";

const BuyButton = ({ href, ...rest }) => (
	<div className="savings-tag-wrapper">
		<img
			src="https://ad.zanox.com/ppc?45685176C89055037"
			align="bottom"
			width="1"
			height="1"
			border="0"
			hspace="1"
		/>
		<a
			className="btn btn-success btn--tag-margin"
			{...rest}
			href={`https://ad.zanox.com/ppc?45685176C89055037&ULP=[[${href}&amp;utm_source=zanox&amp;utm_medium=affiliate&amp;utm_campaign=home]]`}
		>
			<span className="buy">Comprar</span>
		</a>
	</div>
);

export default BuyButton;
